import { render, staticRenderFns } from "./DetailsMaterialsComputation.vue?vue&type=template&id=861d8606&scoped=true&"
import script from "./DetailsMaterialsComputation.vue?vue&type=script&lang=js&"
export * from "./DetailsMaterialsComputation.vue?vue&type=script&lang=js&"
import style0 from "./DetailsMaterialsComputation.vue?vue&type=style&index=0&id=861d8606&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861d8606",
  null
  
)

export default component.exports